import { render, staticRenderFns } from "./LayoutNoSidebar.vue?vue&type=template&id=6973af24"
import script from "./LayoutNoSidebar.vue?vue&type=script&lang=js"
export * from "./LayoutNoSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports